import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'shared/hocs'
import { removeQueryStringParam } from 'shared/helpers/UrlHelper'
import {
  fetchFirstPage, fetchNextPage, fetchHasItems, setPreviousLocation
} from 'LiveBoard/modules/itemsView'
import { load } from 'LiveBoard/componentLoader'
import { FollozeService } from 'LiveBoard/services'
import { QUERY_PARAM } from 'LiveBoard/config/constants'
import { getItemUrl as getItemUrlHelper } from 'LiveBoard/components/shared/itemUrlHelper'
import RoutesService from 'LiveBoard/services/routes'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import get from 'lodash/get'
import pick from 'lodash/pick'

const Items = load('Items/Items')

class ItemsContainer extends React.Component {
  componentDidMount() {
    if(this.props.hasItems) {
      if(!!this.props.selectedCategoryId && isEmpty(this.props.items)) {
        this.props.fetchFirstPage()
      }
    }
    else {
      this.props.fetchHasItems()
    }
  }

  componentDidUpdate(prevProps) {
    const {
      hasItems, selectedCategoryId, items, searchQuery, fetchFirstPage
    } = this.props

    if(this.props.hasItems && !prevProps.hasItems) {
      fetchFirstPage()
    }
    else if(this.props.hasItems && (
      (!isEqual(prevProps.selectedCategoryId, this.props.selectedCategoryId) && isEmpty(this.props.items)) ||
      !isEqual(prevProps.searchQuery, this.props.searchQuery)
    )) {
      fetchFirstPage()
    }
  }

  handleCategoryClick = (categoryId) => {
    const { categories, onCategoryChange } = this.props
    onCategoryChange(categoryId)
    FollozeService.getHost() &&
      FollozeService.getHost().setList(categories[categoryId].name)
  }

  getItemUrlParams = (itemId) => {
    return {
      queryString: removeQueryStringParam(this.props.location.search, QUERY_PARAM),
      category: this.props.categories[this.props.selectedCategoryId],
      item: this.props.items[itemId]
    }
  }

  handleItemClick = (itemId) => {
    const pathParams = RoutesService.matchCategoryPath(window.location.pathname)
    const boardRoute = RoutesService.getBoardRoute(this.props.board, {addHomeSuffix: false})
    const location = !!pathParams ?
      get(pathParams, "params.categorySlug", boardRoute) :
      boardRoute
    this.props.setPreviousLocation(location)
    this.props.onItemClick(this.getItemUrlParams(itemId))
  }

  getItemUrl = (itemId) => {
    return getItemUrlHelper({
      ...this.getItemUrlParams(itemId),
      board: this.props.board
    })
  }

  render() {
    const {
      categoryTheme, themeColorHex, categories, categoryIds, selectedCategoryId, searchQuery,
      items, itemIds, mostViewedItemId, loading, hasMorePages, fetchNextPage,
      shouldFetchNextPage, itemsCount, hasLeadingItem, showViews, boardItems,
      showLikes, showItemType, showHomeCategory, showItemDescription, showSearch, children,
      hasItems, board
    } = this.props

    return (
      <Items
        categoryTheme={categoryTheme}
        themeColorHex={themeColorHex}
        categoryIds={categoryIds}
        categories={categories}
        board={board}
        selectedCategoryId={selectedCategoryId}
        onCategoryClick={this.handleCategoryClick}
        searchQuery={searchQuery}
        hasItems={hasItems}
        showHomeCategory={showHomeCategory}
        showSearch={showSearch} >
        {
          React.cloneElement(children, {
            items,
            itemIds,
            mostViewedItemId,
            themeColorHex,
            hasMorePages,
            isLoading: loading,
            onNextPage: fetchNextPage,
            onItemClick: this.handleItemClick,
            shouldFetchNextPage,
            showViews,
            showLikes,
            showItemType,
            showItemDescription,
            showHomeCategory,
            categories,
            categoryIds,
            selectedCategoryId,
            categoryTheme,
            onCategoryClick: this.handleCategoryClick,
            getItemUrl: this.getItemUrl
          })
        }
      </Items>
    )
  }
}

ItemsContainer.propTypes = {
  categoryTheme: PropTypes.string,
  themeColorHex: PropTypes.string.isRequired,
  searchQuery: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  hasMorePages: PropTypes.bool.isRequired,
  shouldFetchNextPage: PropTypes.bool.isRequired,
  hasLeadingItem: PropTypes.bool.isRequired,
  showViews: PropTypes.bool.isRequired,
  showLikes: PropTypes.bool.isRequired,
  showItemType: PropTypes.bool.isRequired,
  showItemDescription: PropTypes.bool.isRequired,
  showHomeCategory: PropTypes.bool,
  showSearch: PropTypes.bool,
  board: PropTypes.object.isRequired,
  selectedCategoryId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  categories: PropTypes.object,
  categoryIds: PropTypes.array,
  items: PropTypes.object,
  itemIds: PropTypes.array,
  onCategoryChange: PropTypes.func.isRequired,
  itemsCount: PropTypes.number.isRequired,
  mostViewedItemId: PropTypes.number,
  fetchFirstPage: PropTypes.func.isRequired,
  fetchNextPage: PropTypes.func.isRequired,
  fetchHasItems: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  hasItems: PropTypes.bool,
  onItemClick: PropTypes.func.isRequired
}

function mapStateToProps({ board, campaign, categories, itemsView, items}) {
  const {
    loading, categoryId, query, categories: itemsCategories,
    mostViewedItemId, shouldFetchNextPage
  } = itemsView
  const selectedCategory = itemsCategories[categoryId]
  const itemIds = !!selectedCategory ? selectedCategory.itemIds : []
  const showItems = get(campaign.items, 'show', true)

  return {
    board: board,
    themeColorHex: campaign.themeColorHex,
    categories: categories.data,
    categoryIds: categories.categoryIds,
    boardItems: board.online_items_count,
    itemsCount: itemIds.length,
    selectedCategoryId: categoryId,
    searchQuery: query,
    loading,
    items: !!selectedCategory ? pick(items.data, itemIds) : null,
    itemIds,
    mostViewedItemId,
    hasMorePages: !!selectedCategory && selectedCategory.totalPages > selectedCategory.page,
    shouldFetchNextPage,
    hasLeadingItem: !!get(campaign.items, 'leading_item.id'),
    showViews: campaign.items.show_views,
    showLikes: campaign.items.show_likes,
    showItemType: campaign.items.show_item_type,
    showHomeCategory: campaign.items.show_home,
    showSearch: campaign.items.show_search_box,
    hasItems: itemsView.hasItems && showItems
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchFirstPage, fetchNextPage, fetchHasItems, setPreviousLocation
  }, dispatch)
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ItemsContainer)
)